import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useForm, { Form } from "../../../../../hooks/useForm";
import Controls from "../../../../../components/form/controls/Controls";
import { isDisableSubmit } from "../../../utils";
import { validationTTSContextInput } from "../../../utils/validateInput";
import { getTTSEvent } from "src/apis/TTS/event.api";
import { TTSContextType } from "src/pages/TTS/constants";

const initialValue = {
  id: "",
  contextNamespace: "",
  contextName: "",
  type: "success",
  ttsEventIds: [],
};

const contextTypeOption = [
  {
    id: "success",
    name: "Success",
  },
  {
    id: "error",
    name: "Error",
  },
];

const isEmptyContext = (context) => {
  return (
    context &&
    [TTSContextType.SUCCESS_EMPTY, TTSContextType.ERROR_EMPTY].includes(
      context.type
    )
  );
};

const getEventType = (type) => {
  return [TTSContextType.SUCCESS_EMPTY, TTSContextType.SUCCESS].includes(type)
    ? TTSContextType.SUCCESS
    : TTSContextType.ERROR;
};

function TTSContextForm(props) {
  const { addOrEdit, recordForEdit, errorsForm, contextType } = props;
  const [listEvent, setListEvent] = useState([]);
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input permission
  const validateFLFIntentForm = (fieldValues = values) => {
    let temp = validationTTSContextInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFIntentForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFIntentForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    getTTSEvent({ eventType: getEventType(values.type) }, (result) => {
      setListEvent([...result.list]);
    });
  }, [contextType, values.type]);

  useEffect(() => {
    if (recordForEdit !== null) {
      recordForEdit.ttsEventIds = recordForEdit.events.map((event) => event.id);

      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="contextNamespace"
        value={values.contextNamespace}
        label="context name space"
        type="text"
        onChange={handleOnChange}
        error={errors.contextNamespace}
      />

      <Controls.Input
        name="contextName"
        value={values.contextName}
        label="context name"
        type="text"
        onChange={handleOnChange}
        error={errors.contextName}
      />

      <Accordion
        sx={{
          borderRadius: "4px",
          margin: "10px 0",
          padding: "3px 0px",
          background: "unset",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Events</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            height: "200px",
            overflowY: "auto",
            flexDirection: "column",
          }}
        >
          <Divider />
          <Controls.MultipleCheckbox
            name="ttsEventIds"
            label="Events"
            value={values.ttsEventIds}
            onChange={handleOnChange}
            options={listEvent.map((event) => ({
              ...event,
              name: `${event.eventNamespace} -  ${event.eventName}`,
            }))}
          />
        </AccordionDetails>
      </Accordion>

      {!isEmptyContext(recordForEdit) ? (
        <Controls.Select
          name="type"
          label="Type"
          value={values.type}
          onChange={handleOnChange}
          options={contextTypeOption}
          error={errors.type}
        />
      ) : null}

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default TTSContextForm;
